import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/homepage',
      name: 'Index',
      component: () => import('@/views/layout.vue'),
      children: [
        // 首页
        {
          path: 'homepage',
          name: 'homepage',
          meta: { requireLogin: false, title: '福迪生' },
          component: () => import('@/views/index.vue')
        },
        // 公司介绍
        {
          path: 'company',
          name: 'company',
          meta: { requireLogin: false, title: '福迪生' },
          component: () => import('@/views/company.vue')
        },
        // 业务范围
        {
          path: 'business',
          name: 'business',
          meta: { requireLogin: false, title: '福迪生' },
          component: () => import('@/views/business.vue')
        },
        // 联系我们
        {
          path: 'contact',
          name: 'contact',
          meta: { requireLogin: false, title: '福迪生' },
          component: () => import('@/views/contact.vue')
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js